module.exports = __webpack_public_path__ + "static/media/watch3.ececfed9.jpg";